import type { TeamListItem } from "../pages/Teams/teamApi";

const TEAMS_CACHE_PREFIX = "@7Cantos:scheduleTeams:";

/** Teams barely change; the cached list lets the agenda load without waiting for /teams. */
export function readCachedScheduleTeams(userId: number): TeamListItem[] | null {
  try {
    const raw = localStorage.getItem(`${TEAMS_CACHE_PREFIX}${userId}`);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? (parsed as TeamListItem[]) : null;
  } catch {
    return null;
  }
}

export function writeCachedScheduleTeams(userId: number, teams: TeamListItem[]): void {
  try {
    localStorage.setItem(`${TEAMS_CACHE_PREFIX}${userId}`, JSON.stringify(teams));
  } catch {
    // Storage full or blocked: the agenda just waits for /teams as before.
  }
}

/** Keeps the current team, then the saved one, then the first available. */
export function pickScheduleTeamId(
  teams: TeamListItem[],
  currentId: number | null,
  savedId: number | null
): number | null {
  if (teams.length === 0) return null;
  if (currentId != null && teams.some((team) => team.id === currentId)) return currentId;
  if (savedId != null && teams.some((team) => team.id === savedId)) return savedId;
  return teams[0].id;
}
